module.exports = __webpack_public_path__ + "static/media/pizzahurt.08468130.jpg";